export default __webpack_public_path__ + "static/media/StepBg2.090f07fc.svg";